import { useAtomValue } from "jotai";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import _ from "underscore";
import { queriesEnabledAtom } from "../../../../atoms/GlobalAtoms";
import TenantAPI from "../../../api/TenantAPI";
import { BackupRecord } from "@/types/GlobalInterfaces";

const useBackupsHistory = (supportTargetCloudID?: string) => {
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(25);
  const [filter, setFilter] = useState(null);
  const [sortParam, setSortParam] = useState({ order: "", sort: "" });

  const queriesEnabled = useAtomValue(queriesEnabledAtom);

  const queryClient = useQueryClient();

  const goNext = (e: any) => {
    e.preventDefault();
    setPage(page + 1);
  };

  const goBack = (e: any) => {
    e.preventDefault();
    setPage(page - 1);
  };

  const onChangeCount = (val: number) => {
    setPage(1);
    setCount(val);
  };

  const backupHistory = useQuery({
    queryKey: [
      "backupHistory",
      page,
      count,
      sortParam,
      filter,
      supportTargetCloudID || "",
    ],
    queryFn: () =>
      TenantAPI.getBackups(page, count, filter).then((data) => {
        let backupsFound = data.data.data?.RegisteredBackups;
        if (sortParam.order === "asc") {
          backupsFound = _.sortBy(
            backupsFound,
            sortParam.sort === "FileName" ? "Title" : "Date"
          );
        }
        if (sortParam.order === "desc") {
          backupsFound = _.sortBy(
            backupsFound,
            sortParam.sort === "FileName" ? "Title" : "Date"
          ).reverse();
        }

        queryClient.setQueryData(
          ["backupHistory", supportTargetCloudID],
          backupHistory
        );

        return {
          backupRecords: backupsFound,
          records: data?.data?.data?.Pagination?.TotalRecords,
          minRecords: data?.data?.data?.Pagination?.ResultRecordsMin,
          maxRecords: parseInt(data?.data?.data?.Pagination?.ResultRecordsMax),
          hasNext: data?.data?.data?.Pagination?.HasNextPage,
          hasBack: data?.data?.data?.Pagination?.HasPreviousPage,
        };
      }),
    enabled: queriesEnabled,
  });

  return {
    backupHistory: backupHistory?.data?.backupRecords as Array<BackupRecord>,
    minRecords: backupHistory?.data?.minRecords,
    maxRecords: backupHistory?.data?.maxRecords,
    hasNext: backupHistory?.data?.hasNext,
    hasBack: backupHistory?.data?.hasBack,
    backupHistoryLoading: backupHistory?.isLoading,
    goNext: goNext,
    goBack: goBack,
    onChangeCount: onChangeCount,
    recordCount: count,
    page: page,
    sortParam: sortParam,
    setSortParam: setSortParam,
    filter: filter,
    setFilter: setFilter,
  };
};

export default useBackupsHistory;
